import { default as authApi } from './../common/serviceApi'
import { default as authIoApi } from './../common/serviceIoApi'

const qs = require('querystring')

authApi.interceptors.request.use(
  request => {
    const token = getCookie('tkn-ath')
    const refreshToken = getCookie('tkn-ath-rfrsh')
    if(token && refreshToken){
      if(request.url == '/auth/refresh/guest'){
        request.headers['Authorization'] = `${token}`;
      }else{
        request.headers['Authorization'] = `${token}`;
        request.headers['Rate-Limit-Token'] = `${token}`;
        request.headers['Rate-Limit-Refresh-Token'] = ` ${refreshToken}`;
      }
    }
    return request
  },
  error => {
    return Promise.reject(error)
  }
)

authApi.interceptors.response.use(
  response => response,
  // error => new Promise((resolve,reject)=>{
  //   const req = error.config
  //   console.log('axios interceptors response err', error.response)
  //   if(error.response?.status==401 && error.response?.data?.details?.name=="TokenExpiredError"){
  //     //token expiry
  //     req._retry = true
  //     //const refresh_token = sessionStorage.getItem('tkn-ath-rfrsh')
  //     const refresh_token = getCookie('tkn-ath-rfrsh')
  //     refresh({refresh_token})
  //       .then(token=>{
  //         setCookie('tkn-ath', token?.token)
  //         setCookie('tkn-ath-rfrsh', token?.refresh_token)
  //         return token
  //       })
  //       .then((token)=>{
  //         req['headers'] = {
  //           'Authorization': `${token?.token}`
  //         }

  //         if(req?.data)
  //           req['data'] = JSON.parse(req?.data)

  //         return axios(req)          
  //       })
  //       .then(data=>{
  //         resolve(data)
  //       })
  //       .catch(err=>{
  //         reject(err)
  //       })
  //   } else {
  //     reject(error)
  //   }
  // })
)


authIoApi.interceptors.request.use(
  request => {
    const token = getCookie('tkn-ath')
    const refreshToken = getCookie('tkn-ath-rfrsh')
    if(token && refreshToken){
      if(request.url == '/auth/refresh/guest'){
        request.headers['Authorization'] = `${token}`;
      }else{
        request.headers['Authorization'] = `${token}`;
        request.headers['Rate-Limit-Token'] = `${token}`;
        request.headers['Rate-Limit-Refresh-Token'] = ` ${refreshToken}`;
      }
    }
    return request
  },
  error => {
    return Promise.reject(error)
  }
)

authIoApi.interceptors.response.use(
  response => response,
)

const extendCookie = () => {
  const currentToken = getCookie('tkn-ath')
  const currentRfshToken = getCookie('tkn-ath-rfrsh')
  if(currentToken) {
    setCookie('tkn-ath', currentToken)
    setCookie('tkn-ath-rfrsh', currentRfshToken)
  }
}

const getAuthGoogleUrl = (query=null)  => {
    let url = '/auth/google/url'
    if(query){
      url += `?${qs.stringify(query)}`
    }
    return authApi.get(url)
      .then(url=>url.data)
}

const getInitialGuestToken = (query=null) => {
  let url = '/auth/guest'
  const body = {
    "email": "guest.45@email-test.xyz"
  }
  if(query){
    url += `?${qs.stringify(query)}`
  }
  return authApi.post(url,body)
    .then(url=>url.data)
}

const getFinalGuestToken = (refreshToken,query=null ) => {
  let url = '/auth/refresh/guest'
  const body = {
    "refresh_token": refreshToken
  }

  if(query){
    url += `?${qs.stringify(query)}`
  }
  return authApi.post(url,body)
    .then(url=>url.data)
}
const sso = (token, refresh, role) => {
  setCookie('tkn-ath', token)
  setCookie('tkn-ath-rfrsh', refresh)
  if(role){
    setCookie('tkn-ath-role', role)
  }
}


const getCookie = name => {
  let matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
  ));
  return matches ? decodeURIComponent(matches[1]) : null;
}
  
const setCookie = (name, value, options = {}) => {

  options = {
      path: '/',
      // add other defaults here if necessary
      ...options
  };

  if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();
  } else {
      //set default expiry
      const dt = new Date()
      dt.setMinutes( dt.getMinutes() + 11 )
      options.expires = dt.toUTCString()
  }

  let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

  for (let optionKey in options) {
      updatedCookie += "; " + optionKey;
      let optionValue = options[optionKey];
      if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
      }
  }

  document.cookie = updatedCookie;
}

export const useAuthService = ({state, handlers}) => {
  const options = {}
  const { setAuthToken, clearAuthToken } = handlers
  const services = {
    sso: (token,refresh, role) => {
      sso(token, refresh, role)
      setAuthToken(token)
      return token
    },
    logout: () => {
      setCookie('tkn-ath', "")
      setCookie('tkn-ath-rfrsh', "")
      setCookie('tkn-ath-role', "")
      return clearAuthToken()
    },
    isAuth: () => {
      extendCookie()
      return getCookie('tkn-ath') 
    },
    getAuthGoogleUrl,
    getInitialGuestToken,
    getFinalGuestToken,
    setCookie,
    getCookie,

  }
  return [
    state, 
    {
      ...handlers,
      ...services
    }
  ]
}